import {
	RET_ENABLING_CHECKS
} from '../actions/FocusOccasionUploadActions.js';

const initialState = {
	remove: []
};

const FocusOccasionUploadReducer = (state = initialState, action) => {
	switch (action.type) {
					case RET_ENABLING_CHECKS: {
						return {
							...state,
							remove: action.remove
						};
					}
					default: {
						return state;
					}
	}
};

export default FocusOccasionUploadReducer;
